import { Directive } from '@angular/core';
import { NG_VALIDATORS, AbstractControl, ValidationErrors } from '@angular/forms';
import { BaseValidator } from '@tcm-modules/tcm-core.module';

@Directive({
    selector: '[userPasswordValidator]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: UserPasswordValidator, multi: true }
    ],
    standalone: false
})
export class UserPasswordValidator extends BaseValidator {

  constructor() {
    super('userPasswordComplexityRules');
  }

  protected getValidationResult(control: AbstractControl): ValidationErrors {
    let expression = new RegExp('(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*])^(\\S{6,})$', 'g');
    if (control.value) {
      let result = expression.exec(control.value);
      if (!result || result.length == 0) {
        return this.buildValidationErrorResult({});
      }
    }

    return null;
  }
}
